import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PortalProfileService } from 'src/portal/pages/portal-profile/portal-profile.service';

export interface VerifyEmailDialogData {
  emailId: string;
  email: string;
}

@Component({
  selector: 'verify-email-dialog',
  templateUrl: './verify-email.dialog.component.html',
  styleUrls: ['./verify-email.dialog.component.scss'],
  standalone: false
})
export class VerifyEmailDialogComponent implements OnInit {
  otpConfig = {
    length: 6,
    allowNumbersOnly: true,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '·'
  };

  isVerifying = false;
  isResending = false;
  errorMessage: string | null = null;
  resendSuccess = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: VerifyEmailDialogData,
    private dialogRef: MatDialogRef<VerifyEmailDialogComponent>,
    private portalProfileService: PortalProfileService
  ) {}

  ngOnInit(): void {}

  onOtpChange(code: string): void {
    this.errorMessage = null;
    this.resendSuccess = false;
    if (code?.length === 6 && !this.isVerifying) {
      this.submitCode(code);
    }
  }

  async submitCode(code: string): Promise<void> {
    this.isVerifying = true;
    this.errorMessage = null;
    const result = await this.portalProfileService.verifyEmail(this.data.emailId, code);
    this.isVerifying = false;
    if (result.success) {
      this.dialogRef.close(true);
    } else {
      this.errorMessage = result.errorMessage;
    }
  }

  async resendCode(): Promise<void> {
    this.isResending = true;
    this.errorMessage = null;
    this.resendSuccess = false;
    const success = await this.portalProfileService.resendVerificationCode(this.data.emailId);
    this.isResending = false;
    if (success) {
      this.resendSuccess = true;
    }
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
